import { apiSlice } from 'state/slices/apiSlice';

const ANALYTICS_URL = '/analytics';

export const analyticsApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getAnalyticsById: builder.query({
      query: ({ year, month, id}) => `${ANALYTICS_URL}/${year}/${month}/${id}`,
    }),
    getAnalytics: builder.query({
      query: ({ year, month}) => `${ANALYTICS_URL}/${year}/${month}`,
    }),
    updatePayrollNotes: builder.mutation({
      query: (data) => {
        return {
          url: `${ANALYTICS_URL}/update/notes`,
          method: 'PUT',
          body: data,
        };
      }
    }),
    getPayrollNoteById: builder.query({
      query: ({ year, month, id}) => `${ANALYTICS_URL}/notes/${year}/${month}/${id}`,
      extraOptions: { skipToastOn: [404] },
    }),
    deletePayrollNotes: builder.mutation({
      query: ({ year, month, employees}) => ({
        url: `${ANALYTICS_URL}/notes/${year}/${month}`,
        method: 'DELETE',
        body: { employees },
      }),
    }),
  }),
});

export const {
  useGetAnalyticsByIdQuery,
  useGetAnalyticsQuery,
  useUpdatePayrollNotesMutation,
  useGetPayrollNoteByIdQuery,
  useDeletePayrollNotesMutation
} = analyticsApiSlice;
